import { PageIntro } from "../components/portfolio/PageIntro";
import { Seo } from "../components/portfolio/Seo";
import { Photography } from "../components/portfolio/Photography";
import { MiniFooter } from "../components/portfolio/MiniFooter";

export default function PhotographyPage() {
  return (
    <div className="pt-20">
      <Seo
        title="Photography & Videography"
        description="Two decades behind the camera: events, portraits, and film. Chair of Media, Communications & Digital Innovation at Timbaland Way Cares."
      />
      <PageIntro kicker="Photography & Videography">
        Two decades documenting people, events, and stories, from Chicago tour boats to the music industry.
      </PageIntro>
      <Photography />
      <MiniFooter />
    </div>
  );
}
